import { ExternalRedeemModal } from './ExternalRedeemModal'
import { useWebSession } from '@/hooks/useWebSession'

/**
 * Page wrapper for the ExternalRedeemModal that handles context setup
 * This component is used as a route element and manages:
 * - Web session detection and token handling for mobile app users
 * - Policy opt-ins suppression
 */
export const ExternalRedeemPage: React.FC = () => {
  const { token, isWebSession, isExpired, isInitializing, sessionError } = useWebSession()

  // Show loading while initializing web session
  if (isWebSession && isInitializing) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-500 mx-auto mb-4"></div>
          <p className="text-gray-600">Loading...</p>
        </div>
      </div>
    )
  }

  // Show error if web session expired or failed
  if (isWebSession && (isExpired || sessionError)) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center max-w-md p-6">
          <div className="text-red-500 mb-4">
            <svg className="w-16 h-16 mx-auto" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
              />
            </svg>
          </div>
          <h2 className="text-xl font-semibold mb-2 text-gray-800">Session Expired</h2>
          <p className="text-gray-600 mb-4">
            {sessionError || 'Your session has expired. Please close this window and try again from the app.'}
          </p>
        </div>
      </div>
    )
  }

  // Pass web session token to modal if available
  return <ExternalRedeemModal token={token} />
}

export default ExternalRedeemPage
